import "./chunk--chunk-RQ7252KT.js";

// src/js/components/Video.js
var Video = class {
  constructor(el) {
    this.video = el.querySelector("video");
    this.progressBar = el.querySelector("progress");
    this.options = el.getAttribute("data-video");
    this.muteButton = el.querySelector("[data-mute-button]");
    if (this.options) {
      this.options = JSON.parse(this.options);
    }
    this.progressDuration = false;
    this.currentTime = false;
  }
  init() {
    if (this.progressBar)
      this.initProgressBar();
    if (this.options && this.options.inView)
      this.initIntersectionObserver();
    this.initMuteButton();
    this.dispatchVideoEnd();
  }
  initProgressBar() {
    this.video.addEventListener("play", () => {
      setInterval(() => {
        if (this.video && this.video.currentTime && this.video.duration) {
          this.progressBar.value = Math.round(this.video.currentTime / this.video.duration * 100);
        }
      });
    });
  }
  initMuteButton() {
    const mute = this.muteButton.querySelector("[data-mute]");
    const unmute = this.muteButton.querySelector("[data-unmute]");
    this.muteButton.addEventListener("click", () => {
      this.video.muted = !this.video.muted;
      mute.classList.toggle("hidden");
      unmute.classList.toggle("hidden");
    });
    this.video.addEventListener("pause", () => {
      this.video.muted = true;
      mute.classList.add("hidden");
      unmute.classList.remove("hidden");
    });
  }
  initIntersectionObserver() {
    const videoObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        if (this.video.closest(".slide-inactive") || !this.video.closest(".splide__slide").classList.contains("is-active")) {
          this.video.pause();
          return;
        }
        setTimeout(() => {
          this.video.play();
        }, 500);
      } else {
        this.video.pause();
      }
    });
    videoObserver.observe(this.video);
  }
  dispatchVideoEnd() {
    this.video.addEventListener("ended", () => {
      document.dispatchEvent(
        new CustomEvent("video end", {
          detail: {
            video: this.video,
            changeSlide: this.options.changeSlide
          }
        })
      );
    });
  }
};
var Video_default = Video;
export {
  Video_default as default
};
